export const clientData: Record<string, any> = {
  'vistara-airlines': {
    name: 'Vistara Airlines',
    logo: '/images/logos/vistara.png',
    industry: 'Airlines & Aviation',
    duration: '2018 - 2024',
    teamSize: '38 Full-time Employees',
    description: 'Vistara Airlines is a full-service carrier and a joint venture between Tata Sons and Singapore Airlines. We provided comprehensive IT support across development, security, networking, and database management.',
    overview: 'Our partnership with Vistara Airlines represents one of our largest and most comprehensive engagements. Over 6 years, we built and maintained critical systems that support their daily operations, passenger services, and business intelligence.',
    projects: [
      {
        name: 'Flight Management System',
        duration: '2018 - 2020',
        team: '12 Developers',
        description: 'Complete overhaul of the flight management system including real-time tracking, crew scheduling, and maintenance management.',
        technologies: ['Java', 'Spring Boot', 'PostgreSQL', 'Redis', 'Docker'],
        achievements: [
          'Reduced flight delay processing time by 40%',
          'Improved crew scheduling efficiency by 35%',
          'Achieved 99.9% system uptime'
        ]
      },
      {
        name: 'Customer Portal & Mobile App',
        duration: '2019 - 2021',
        team: '8 Developers',
        description: 'Development of customer-facing portal and mobile application for booking, check-in, and loyalty management.',
        technologies: ['React', 'React Native', 'Node.js', 'MongoDB', 'AWS'],
        achievements: [
          'Increased online bookings by 60%',
          'Achieved 4.8/5 app store rating',
          'Reduced customer service calls by 25%'
        ]
      },
      {
        name: 'Security & Compliance Framework',
        duration: '2020 - 2022',
        team: '6 Security Specialists',
        description: 'Implementation of comprehensive security framework meeting aviation industry standards and regulations.',
        technologies: ['SIEM', 'WAF', 'PKI', 'IAM', 'Encryption'],
        achievements: [
          'Achieved SOC 2 Type II compliance',
          'Zero security incidents in 2 years',
          'Reduced security audit time by 50%'
        ]
      },
      {
        name: 'Data Analytics & Business Intelligence',
        duration: '2021 - 2024',
        team: '12 Data Engineers & Analysts',
        description: 'Built comprehensive data platform for business intelligence, predictive analytics, and operational insights.',
        technologies: ['Python', 'Apache Spark', 'Tableau', 'Snowflake', 'Kubernetes'],
        achievements: [
          'Reduced fuel costs by 8% through predictive analytics',
          'Improved route optimization by 15%',
          'Generated $2M+ in cost savings annually'
        ]
      }
    ],
    technologies: ['Java', 'React', 'Python', 'AWS', 'PostgreSQL', 'MongoDB', 'Docker', 'Kubernetes'],
    achievements: [
      'Supported 15M+ passengers annually',
      'Maintained 99.9% system availability',
      'Generated $50M+ in cost savings',
      'Zero critical security incidents'
    ],
    team: [
      { name: 'Rajesh Kumar', role: 'Project Director', experience: '15 years' },
      { name: 'Priya Sharma', role: 'Lead Developer', experience: '12 years' },
      { name: 'Amit Patel', role: 'Security Architect', experience: '10 years' },
      { name: 'Sneha Reddy', role: 'Data Engineer', experience: '8 years' }
    ]
  },
  'quest-diagnostics': {
    name: 'Quest Diagnostics',
    logo: '/images/logos/quest-diagnostics.jpeg',
    industry: 'Healthcare & Diagnostics',
    duration: '2020 - Present',
    teamSize: '22 Full-time Employees',
    description: 'Quest Diagnostics is a leading provider of diagnostic information services. We support their digital transformation initiatives across development, security, networking, infrastructure, database, and QA.',
    overview: 'Our ongoing partnership with Quest Diagnostics focuses on modernizing their healthcare IT infrastructure while maintaining the highest standards of security and compliance required in the healthcare industry.',
    projects: [
      {
        name: 'Laboratory Information Management System (LIMS)',
        duration: '2020 - 2022',
        team: '8 Developers',
        description: 'Modernization of the core LIMS platform to handle increased testing volume and improve operational efficiency.',
        technologies: ['.NET Core', 'SQL Server', 'Azure', 'Microservices', 'Docker'],
        achievements: [
          'Increased test processing capacity by 45%',
          'Reduced result turnaround time by 30%',
          'Achieved HIPAA compliance certification'
        ]
      },
      {
        name: 'Patient Portal & Mobile App',
        duration: '2021 - 2023',
        team: '6 Developers',
        description: 'Development of patient-facing portal and mobile application for test results, appointment scheduling, and health records.',
        technologies: ['React', 'React Native', 'Node.js', 'MongoDB', 'Azure AD'],
        achievements: [
          'Increased patient engagement by 70%',
          'Reduced call center volume by 40%',
          'Achieved 4.7/5 patient satisfaction rating'
        ]
      },
      {
        name: 'Cloud Infrastructure Migration',
        duration: '2022 - 2023',
        team: '4 Cloud Engineers',
        description: 'Migration of on-premises infrastructure to Microsoft Azure with focus on security and compliance.',
        technologies: ['Azure', 'Terraform', 'Kubernetes', 'Azure AD', 'Azure Security Center'],
        achievements: [
          'Reduced infrastructure costs by 35%',
          'Improved system scalability by 200%',
          'Achieved SOC 2 and HIPAA compliance'
        ]
      },
      {
        name: 'AI-Powered Diagnostic Analytics',
        duration: '2023 - Present',
        team: '4 Data Scientists & Engineers',
        description: 'Implementation of AI and machine learning solutions for diagnostic pattern recognition and predictive analytics.',
        technologies: ['Python', 'TensorFlow', 'Azure ML', 'Power BI', 'Apache Kafka'],
        achievements: [
          'Improved diagnostic accuracy by 12%',
          'Reduced false positive rates by 25%',
          'Enabled early disease detection capabilities'
        ]
      }
    ],
    technologies: ['.NET Core', 'React', 'Python', 'Azure', 'SQL Server', 'MongoDB', 'Docker', 'Kubernetes'],
    achievements: [
      'Processed 50M+ tests annually',
      'Maintained 99.95% system uptime',
      'Achieved full HIPAA compliance',
      'Reduced operational costs by 30%'
    ],
    team: [
      { name: 'Dr. Michael Chen', role: 'Healthcare IT Director', experience: '18 years' },
      { name: 'Sarah Johnson', role: 'Lead .NET Developer', experience: '14 years' },
      { name: 'David Kim', role: 'Cloud Security Architect', experience: '12 years' },
      { name: 'Lisa Wang', role: 'Data Science Lead', experience: '10 years' }
    ]
  },
  'freddiemac': {
    name: 'FreddieMac',
    logo: '/images/logos/freddiemac.png',
    industry: 'Financial Services',
    duration: '2018 - Present',
    teamSize: '12 Full-time Employees',
    description: 'Freddie Mac is a government-sponsored enterprise that provides liquidity, stability, and affordability to the U.S. housing market. We support their network security, infrastructure, and security projects.',
    overview: 'Our long-term partnership with Freddie Mac focuses on maintaining the highest levels of security and compliance while supporting their mission to make homeownership more accessible and affordable.',
    projects: [
      {
        name: 'Network Security Infrastructure',
        duration: '2018 - 2020',
        team: '4 Security Engineers',
        description: 'Implementation of comprehensive network security framework including firewalls, intrusion detection, and monitoring systems.',
        technologies: ['Cisco ASA', 'Palo Alto', 'Splunk', 'SIEM', 'NAC'],
        achievements: [
          'Reduced security incidents by 80%',
          'Achieved zero data breaches',
          'Compliant with FFIEC guidelines'
        ]
      },
      {
        name: 'Cloud Security Migration',
        duration: '2020 - 2022',
        team: '5 Cloud Engineers',
        description: 'Migration of critical systems to AWS with enhanced security controls and compliance monitoring.',
        technologies: ['AWS', 'Terraform', 'CloudFormation', 'AWS Security Hub', 'GuardDuty'],
        achievements: [
          'Improved security posture by 60%',
          'Reduced compliance audit time by 50%',
          'Achieved SOC 2 Type II certification'
        ]
      },
      {
        name: 'Identity & Access Management',
        duration: '2021 - 2023',
        team: '3 IAM Specialists',
        description: 'Implementation of enterprise-wide identity and access management solution with multi-factor authentication.',
        technologies: ['Okta', 'Azure AD', 'SAML', 'OAuth', 'RBAC'],
        achievements: [
          'Reduced access provisioning time by 75%',
          'Eliminated unauthorized access incidents',
          'Improved user experience significantly'
        ]
      }
    ],
    technologies: ['AWS', 'Cisco', 'Palo Alto', 'Okta', 'Splunk', 'Terraform', 'Python', 'PowerShell'],
    achievements: [
      'Zero security breaches in 6 years',
      'Maintained 99.99% system availability',
      'Achieved full regulatory compliance',
      'Reduced security costs by 40%'
    ],
    team: [
      { name: 'Robert Martinez', role: 'Security Director', experience: '20 years' },
      { name: 'Jennifer Lee', role: 'Network Security Lead', experience: '15 years' },
      { name: 'Thomas Wilson', role: 'Cloud Security Architect', experience: '12 years' }
    ]
  },
  'upmc': {
    name: 'UPMC',
    logo: '/images/logos/upmc.png',
    industry: 'Healthcare & Life Sciences',
    duration: '2018 - Present',
    teamSize: '8 Full-time Employees',
    description: 'UPMC is a world-renowned health care provider and insurer. We provide comprehensive .NET, networking, and security implementation services.',
    overview: 'Our partnership with UPMC focuses on maintaining their critical healthcare IT infrastructure while ensuring the highest levels of security and compliance required in the healthcare industry.',
    projects: [
      {
        name: 'Electronic Health Records System',
        duration: '2018 - 2020',
        team: '4 .NET Developers',
        description: 'Enhancement and maintenance of the core EHR system to improve patient care and operational efficiency.',
        technologies: ['.NET Framework', 'SQL Server', 'WPF', 'WCF', 'IIS'],
        achievements: [
          'Improved patient data access by 50%',
          'Reduced data entry errors by 30%',
          'Achieved HITRUST certification'
        ]
      },
      {
        name: 'Network Security Infrastructure',
        duration: '2019 - 2021',
        team: '3 Network Engineers',
        description: 'Implementation of comprehensive network security measures to protect patient data and ensure HIPAA compliance.',
        technologies: ['Cisco', 'Palo Alto', 'SIEM', 'NAC', 'VPN'],
        achievements: [
          'Zero data breaches in 3 years',
          'Achieved 99.99% network uptime',
          'Compliant with HIPAA regulations'
        ]
      },
      {
        name: 'Cloud Migration & Modernization',
        duration: '2021 - Present',
        team: '5 Cloud Engineers',
        description: 'Migration of legacy systems to Microsoft Azure with enhanced security and scalability.',
        technologies: ['.NET Core', 'Azure', 'Docker', 'Kubernetes', 'Azure AD'],
        achievements: [
          'Reduced infrastructure costs by 40%',
          'Improved system performance by 60%',
          'Enhanced disaster recovery capabilities'
        ]
      }
    ],
    technologies: ['.NET', 'SQL Server', 'Azure', 'Cisco', 'Docker', 'Kubernetes', 'PowerShell', 'C#'],
    achievements: [
      'Served 3M+ patients annually',
      'Maintained 99.99% system uptime',
      'Achieved full HIPAA compliance',
      'Reduced operational costs by 35%'
    ],
    team: [
      { name: 'Dr. Sarah Thompson', role: 'Healthcare IT Director', experience: '16 years' },
      { name: 'Mark Rodriguez', role: 'Lead .NET Developer', experience: '13 years' },
      { name: 'Jennifer Liu', role: 'Network Security Lead', experience: '11 years' }
    ]
  },
  'boeing': {
    name: 'Boeing',
    logo: '/images/logos/boeing.png',
    industry: 'Aerospace & Defense',
    duration: 'Jan 2020 - Present',
    teamSize: '6 Full-time Employees',
    description: 'Boeing is the world\'s largest aerospace company. We provide ongoing system integration and existing software enhancements.',
    overview: 'Our partnership with Boeing focuses on maintaining and enhancing their critical aerospace systems while ensuring the highest standards of safety and reliability.',
    projects: [
      {
        name: 'Aircraft Systems Integration',
        duration: '2020 - 2022',
        team: '3 Integration Specialists',
        description: 'Integration of various aircraft systems and components to ensure seamless operation and safety compliance.',
        technologies: ['C++', 'Java', 'Python', 'Docker', 'Kubernetes'],
        achievements: [
          'Improved system reliability by 25%',
          'Reduced integration time by 40%',
          'Achieved FAA certification compliance'
        ]
      },
      {
        name: 'Legacy System Modernization',
        duration: '2021 - Present',
        team: '3 Software Engineers',
        description: 'Modernization of legacy aerospace software systems to improve performance and maintainability.',
        technologies: ['.NET Core', 'React', 'PostgreSQL', 'AWS', 'Microservices'],
        achievements: [
          'Reduced maintenance costs by 30%',
          'Improved system performance by 45%',
          'Enhanced code maintainability'
        ]
      }
    ],
    technologies: ['C++', 'Java', '.NET Core', 'React', 'PostgreSQL', 'AWS', 'Docker', 'Kubernetes'],
    achievements: [
      'Supported 1000+ aircraft systems',
      'Maintained 99.99% system reliability',
      'Achieved full FAA compliance',
      'Reduced system downtime by 50%'
    ],
    team: [
      { name: 'James Anderson', role: 'Aerospace Systems Director', experience: '20 years' },
      { name: 'Maria Garcia', role: 'Lead Integration Engineer', experience: '15 years' },
      { name: 'David Kim', role: 'Software Modernization Lead', experience: '12 years' }
    ]
  },
  'tennessee-valley-authority': {
    name: 'Tennessee Valley Authority',
    logo: '/images/logos/tva.png',
    industry: 'Energy & Utilities',
    duration: '2020 - Present',
    teamSize: '6 Full-time Employees',
    description: 'TVA is a federally owned corporation that provides electricity to 10 million people. We implement projects covering .NET, security, networking, and database technologies.',
    overview: 'Our partnership with TVA focuses on modernizing their power grid systems and ensuring robust cybersecurity for critical infrastructure.',
    projects: [
      {
        name: 'Smart Grid Management System',
        duration: '2020 - 2022',
        team: '3 .NET Developers',
        description: 'Development of smart grid management system for improved power distribution and monitoring.',
        technologies: ['.NET Core', 'SQL Server', 'Azure', 'IoT', 'Power BI'],
        achievements: [
          'Improved grid efficiency by 20%',
          'Reduced power outages by 35%',
          'Enhanced real-time monitoring capabilities'
        ]
      },
      {
        name: 'Cybersecurity Framework',
        duration: '2021 - 2023',
        team: '3 Security Specialists',
        description: 'Implementation of comprehensive cybersecurity framework for critical infrastructure protection.',
        technologies: ['SIEM', 'NIST Framework', 'Zero Trust', 'IAM', 'Encryption'],
        achievements: [
          'Achieved NIST compliance',
          'Zero security incidents',
          'Enhanced threat detection by 80%'
        ]
      }
    ],
    technologies: ['.NET Core', 'SQL Server', 'Azure', 'SIEM', 'Power BI', 'IoT', 'Docker', 'Kubernetes'],
    achievements: [
      'Served 10M+ customers',
      'Maintained 99.99% grid reliability',
      'Achieved NIST compliance',
      'Reduced cybersecurity risks by 70%'
    ],
    team: [
      { name: 'Robert Johnson', role: 'Energy Systems Director', experience: '18 years' },
      { name: 'Lisa Chen', role: 'Smart Grid Lead', experience: '14 years' },
      { name: 'Michael Brown', role: 'Cybersecurity Architect', experience: '16 years' }
    ]
  },
  'red-wing-shoe': {
    name: 'Red Wing Shoe',
    logo: '/images/logos/red-wing-shoe.png',
    industry: 'Retail & Manufacturing',
    duration: 'March 2022 - Present',
    teamSize: '5 Full-time Employees',
    description: 'Red Wing Shoes is a manufacturer of work and heritage footwear. We provide full-stack .NET and Blazor application development and support.',
    overview: 'Our partnership with Red Wing Shoes focuses on modernizing their retail and manufacturing systems to improve customer experience and operational efficiency.',
    projects: [
      {
        name: 'E-commerce Platform',
        duration: '2022 - 2023',
        team: '3 Full-stack Developers',
        description: 'Development of modern e-commerce platform using .NET and Blazor for online sales and customer management.',
        technologies: ['.NET 6', 'Blazor Server', 'SQL Server', 'Azure', 'Stripe API'],
        achievements: [
          'Increased online sales by 60%',
          'Improved page load time by 50%',
          'Enhanced mobile shopping experience'
        ]
      },
      {
        name: 'Inventory Management System',
        duration: '2022 - Present',
        team: '2 Backend Developers',
        description: 'Development of real-time inventory management system for manufacturing and retail operations.',
        technologies: ['.NET Core', 'Entity Framework', 'SignalR', 'Redis', 'Azure Functions'],
        achievements: [
          'Reduced inventory discrepancies by 40%',
          'Improved order fulfillment by 35%',
          'Real-time inventory tracking'
        ]
      }
    ],
    technologies: ['.NET 6', 'Blazor', 'SQL Server', 'Azure', 'Entity Framework', 'SignalR', 'Redis', 'Stripe'],
    achievements: [
      'Increased online revenue by 60%',
      'Reduced inventory costs by 25%',
      'Improved customer satisfaction by 40%',
      'Streamlined manufacturing processes'
    ],
    team: [
      { name: 'Alex Thompson', role: 'Retail Systems Director', experience: '12 years' },
      { name: 'Rachel Davis', role: 'Lead Blazor Developer', experience: '8 years' },
      { name: 'Kevin Wilson', role: 'Backend Systems Lead', experience: '10 years' }
    ]
  },
  'collins-aerospace': {
    name: 'Collins Aerospace',
    logo: '/images/logos/collins-aerospace.png',
    industry: 'Aerospace & Defense',
    duration: 'Sep 2023 - Present',
    teamSize: '4 Full-time Employees',
    description: 'Collins Aerospace is a technology and manufacturing company. We provide comprehensive support across SAP, Talend, Kinaxis, and software engineering.',
    overview: 'Our partnership with Collins Aerospace focuses on optimizing their enterprise systems and improving operational efficiency across their aerospace operations.',
    projects: [
      {
        name: 'SAP S/4HANA Migration',
        duration: '2023 - Present',
        team: '2 SAP Specialists',
        description: 'Migration from legacy SAP systems to S/4HANA for improved performance and modern functionality.',
        technologies: ['SAP S/4HANA', 'ABAP', 'Fiori', 'SAP PI', 'SAP BW'],
        achievements: [
          'Improved system performance by 50%',
          'Reduced data processing time by 40%',
          'Enhanced reporting capabilities'
        ]
      },
      {
        name: 'Data Integration Platform',
        duration: '2023 - Present',
        team: '2 Data Engineers',
        description: 'Implementation of Talend-based data integration platform for seamless data flow across systems.',
        technologies: ['Talend', 'Apache Kafka', 'PostgreSQL', 'Docker', 'Kubernetes'],
        achievements: [
          'Reduced data integration time by 60%',
          'Improved data quality by 45%',
          'Real-time data processing capabilities'
        ]
      }
    ],
    technologies: ['SAP S/4HANA', 'Talend', 'Kinaxis', 'ABAP', 'Fiori', 'Apache Kafka', 'PostgreSQL', 'Docker'],
    achievements: [
      'Improved system performance by 50%',
      'Reduced data processing time by 40%',
      'Enhanced operational efficiency by 35%',
      'Streamlined supply chain processes'
    ],
    team: [
      { name: 'Dr. Amanda Foster', role: 'Enterprise Systems Director', experience: '17 years' },
      { name: 'Carlos Mendez', role: 'SAP Lead Consultant', experience: '13 years' },
      { name: 'Sarah Kim', role: 'Data Integration Specialist', experience: '9 years' }
    ]
  },
  'netchex': {
    name: 'Netchex',
    logo: '/images/logos/netchex.png',
    industry: 'Technology & Software',
    duration: '2024 - Present',
    teamSize: '2 Full-time Employees',
    description: 'Netchex is a cloud-based payroll and HR software company. We provide software development project support as Subject Matter Experts.',
    overview: 'Our partnership with Netchex focuses on enhancing their cloud-based platform and providing expert guidance on software architecture and development best practices.',
    projects: [
      {
        name: 'Platform Enhancement',
        duration: '2024 - Present',
        team: '2 Software Engineers',
        description: 'Enhancement of the core Netchex platform with improved performance and new features.',
        technologies: ['.NET Core', 'React', 'Azure', 'SQL Server', 'Microservices'],
        achievements: [
          'Improved platform performance by 30%',
          'Enhanced user experience',
          'Added new payroll features'
        ]
      }
    ],
    technologies: ['.NET Core', 'React', 'Azure', 'SQL Server', 'Microservices', 'Docker', 'Kubernetes', 'Power BI'],
    achievements: [
      'Improved platform performance by 30%',
      'Enhanced user experience',
      'Reduced development time by 25%',
      'Improved code quality'
    ],
    team: [
      { name: 'Jennifer Walsh', role: 'Software Development Lead', experience: '11 years' },
      { name: 'Ryan O\'Connor', role: 'Cloud Architecture Specialist', experience: '8 years' }
    ]
  },
  'ncdot': {
    name: 'NCDOT',
    logo: '/images/logos/ncdot.png',
    industry: 'Government & Public Sector',
    duration: 'June 2020 - Present',
    teamSize: '8 Full-time Employees',
    description: 'NCDOT (North Carolina Department of Transportation) is responsible for maintaining and improving the state\'s transportation infrastructure. We have implemented end-to-end Oracle HCM implementation and support with our 8-member team.',
    overview: 'Our partnership with NCDOT focuses on comprehensive Oracle HCM implementation and ongoing support to streamline their human resources and workforce management processes. We have also provided web development support to enhance their digital infrastructure and improve public-facing services.',
    projects: [
      {
        name: 'Oracle HCM Cloud Implementation',
        duration: 'June 2020 - Dec 2020',
        team: '6 HCM Specialists',
        description: 'Complete end-to-end implementation of Oracle HCM Cloud including Core HR, Payroll, Benefits, Talent Management, and Workforce Management modules.',
        technologies: ['Oracle HCM Cloud', 'Oracle Integration Cloud', 'Oracle Analytics Cloud', 'SQL', 'PL/SQL'],
        achievements: [
          'Successfully migrated 10,000+ employee records',
          'Reduced HR processing time by 50%',
          'Achieved 100% data accuracy in migration',
          'Implemented automated payroll processing'
        ]
      },
      {
        name: 'Oracle HCM Support & Maintenance',
        duration: 'Jan 2021 - Present',
        team: '5 HCM Support Specialists',
        description: 'Ongoing support, maintenance, and enhancement of Oracle HCM Cloud system including regular updates, customizations, and user training.',
        technologies: ['Oracle HCM Cloud', 'Fast Formulas', 'BI Publisher', 'HCM Extracts', 'Workflow Builder'],
        achievements: [
          'Maintained 99.9% system uptime',
          'Reduced support ticket resolution time by 40%',
          'Implemented 50+ custom reports and dashboards',
          'Conducted training for 500+ HR users'
        ]
      },
      {
        name: 'Web Development & Digital Services',
        duration: '2021 - Present',
        team: '3 Web Developers',
        description: 'Development and maintenance of public-facing web applications and internal portals to improve citizen services and employee experience.',
        technologies: ['.NET Core', 'React', 'SQL Server', 'Azure', 'REST APIs', 'JavaScript'],
        achievements: [
          'Improved website performance by 45%',
          'Enhanced user experience and accessibility',
          'Reduced page load time by 60%',
          'Implemented responsive design for mobile devices'
        ]
      }
    ],
    technologies: ['Oracle HCM Cloud', 'Oracle Integration Cloud', '.NET Core', 'React', 'SQL Server', 'Azure', 'JavaScript', 'REST APIs'],
    achievements: [
      'Successfully implemented Oracle HCM for 10,000+ employees',
      'Maintained 99.9% system availability',
      'Reduced HR processing time by 50%',
      'Improved web services performance by 45%',
      'Zero critical system incidents'
    ],
    team: [
      { name: 'Michael Thompson', role: 'Oracle HCM Director', experience: '15 years' },
      { name: 'Patricia Martinez', role: 'Lead HCM Consultant', experience: '12 years' },
      { name: 'Robert Chen', role: 'Web Development Lead', experience: '10 years' },
      { name: 'Lisa Anderson', role: 'HCM Support Specialist', experience: '8 years' }
    ]
  }
};

